import { objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { keys } from '../constants/keys.esm.js';
import { LayoutType } from '../types/layouts.esm.js';
import { getNewLayoutId } from './get-new-layout-id.esm.js';
import { sortLayouts } from './sort-layouts.esm.js';

var changeSelectedLayout = function changeSelectedLayout(resources, lockedFields) {
  return function (layouts, id, type) {
    switch (type) {
      case LayoutType.Default:
        {
          return layouts.filter(function (layout) {
            return layout.type !== LayoutType.Custom;
          }).map(function (layout) {
            var selected = layout.type === LayoutType.Default;
            return getNewLayoutId(_objectSpread2(_objectSpread2({}, layout), {}, {
              selected: selected
            }));
          });
        }
      case LayoutType.Custom:
        {
          var newLayouts = layouts.map(function (layout) {
            var selected = false;
            return getNewLayoutId(_objectSpread2(_objectSpread2({}, layout), {}, {
              selected: selected
            }));
          });
          var newLayout = {
            type: LayoutType.Custom,
            fields: lockedFields,
            id: keys.custom,
            label: resources.custom(),
            selected: true
          };
          return sortLayouts([].concat(_toConsumableArray(newLayouts), [newLayout]));
        }
      default:
        {
          return layouts.filter(function (layout) {
            return layout.type !== LayoutType.Custom;
          }).map(function (layout) {
            var selected = layout.id === id;
            return getNewLayoutId(_objectSpread2(_objectSpread2({}, layout), {}, {
              selected: selected
            }));
          });
        }
    }
  };
};

export { changeSelectedLayout };
//# sourceMappingURL=change-selected-layout.esm.js.map
